import React, { useEffect, useState } from "react";
import { Col, Row, Breadcrumb, Card, Badge } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import axios from "axios";
import config from "../../config";
import { useAuth } from "../../context/AuthContext";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { AutoComplete } from "primereact/autocomplete";
import moment from "moment";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import '../../assets/css/taskboard.css';
import { useNavigate } from 'react-router-dom';
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from 'primereact/tooltip';
import { VscFlame } from "react-icons/vsc";
import CustomConfirmPopup from "../../components/CustomConfirmPopup";
import { Skeleton } from "primereact/skeleton";
import noUserImg from '../../assets/images/no_user.png'; // Placeholder for missing profile images
import successVideo from '../../assets/video/paperplane.mp4';
import crossVideo from '../../assets/video/cross.mp4';
import { Sidebar } from 'primereact/sidebar';
import Chat_page from "./Chat_page";
import { TfiComments } from "react-icons/tfi";
import UnifiedTaskDetails from "../../components/UnifiedTaskDetails";
const initialColumns = {
    Todo: [],
    InProgress: [],
    InReview: [],
    InChanges: [],
    Completed: [],
};

const Taskboard_admin = () => {
    const { accessToken, userId, role } = useAuth();
    const [columns, setColumns] = useState(initialColumns);
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [commentCounts, setCommentCounts] = useState({});
    const [isLoading, setIsLoading] = useState(false); // Add loading state
    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [dateFilterType, setDateFilterType] = useState("startdate"); // Default to task_startdate
    const [includeCompleted, setIncludeCompleted] = useState(false); // Default: false
    // Options for dropdown
    const completionOptions = [
        { label: "Exclude Completed", value: false },
        { label: "Include Completed", value: true },
    ];
    const [taskType, setTaskType] = useState(localStorage.getItem("taskType") || ""); // Load from local storage
    const [selectedBrand, setSelectedBrand] = useState(() => {
        const brand = localStorage.getItem("selectedBrand");
        return brand ? JSON.parse(brand) : null;
    });
    const [dateRange, setDateRange] = useState(() => {
        const range = localStorage.getItem("dateRange");
        if (range) {
            const parsedRange = JSON.parse(range);
            return {
                startDate: moment(parsedRange.startDate), // Convert back to moment object
                endDate: moment(parsedRange.endDate), // Convert back to moment object
            };
        }
        return {
            startDate: moment().startOf("week"),
            endDate: moment().endOf("week"),
        };
    });

    // Initialize state with stored value or null
    const [taskSearchUser, setTaskSearchUser] = useState(() => {
        const storedUser = localStorage.getItem("taskSearchUser");
        return storedUser ? JSON.parse(storedUser) : null;
    });
    // State for search suggestions
    const [filteredUsers, setFilteredUsers] = useState([]);

    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder',
        'Admin',
        'SuperAdmin',
        'HumanResource',
        'Accounts',
        'Department_Head',
        'Task_manager'
    ];

    const employeeallowedRoles = [
        'Employee',
        'Social_Media_Manager'

    ];


    const [visibleRight, setVisibleRight] = useState(false);
    const [taskDetailsVisible, setTaskDetailsVisible] = useState(false);
    const [viewTaskId, setViewTaskId] = useState(null);



    const [isDialogVisible, setDialogVisible] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [formData, setFormData] = useState({
        startDate: null,
        endDate: null,
        userId: null,
    });

    const [isDeadlineDialogVisible, setDeadlineDialogVisible] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [newDeadline, setNewDeadline] = useState(null);



    // Save filters to local storage whenever they change
    useEffect(() => {
        localStorage.setItem("taskType", taskType);
    }, [taskType]);

    useEffect(() => {
        if (selectedBrand) {
            localStorage.setItem("selectedBrand", JSON.stringify(selectedBrand));
        } else {
            localStorage.removeItem("selectedBrand");
        }
    }, [selectedBrand]);

    useEffect(() => {
        localStorage.setItem(
            "dateRange",
            JSON.stringify({
                startDate: dateRange.startDate.toISOString(), // Store as ISO string
                endDate: dateRange.endDate.toISOString(), // Store as ISO string
            })
        );
    }, [dateRange]);

    // Update localStorage when state changes
    useEffect(() => {
        if (taskSearchUser) {
            localStorage.setItem("taskSearchUser", JSON.stringify(taskSearchUser));
        }
    }, [taskSearchUser]);

    // Filter users based on input
    const searchUsers = (event) => {
        let query = event.query.toLowerCase();
        let filtered = users.filter((user) =>
            `${user.first_name} ${user.last_name}`.toLowerCase().includes(query)
        );
        setFilteredUsers(filtered);
    };

    // Fetch tasks from the API
    const fetchTasks = async () => {
        try {
            setIsLoading(true); // Set loading state

            // Determine the correct user_id to send
            const selectedUserId =
                allowedRoles.includes(role) && taskSearchUser?.user_id
                    ? taskSearchUser.user_id
                    : userId;

            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/tasks/kanban`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    user_id: selectedUserId, // Dynamically set user_id
                    brand_id: selectedBrand?.brand_id || null,
                    start_date: dateRange.startDate.format("YYYY-MM-DD"),
                    end_date: dateRange.endDate.format("YYYY-MM-DD"),
                    task_type: taskType || null, // Only include task_type if selected
                    date_filter_type: dateFilterType, // Pass date filter type
                    include_completed: includeCompleted, // Pass the new filter
                },
            });

            const data = response.data?.data || initialColumns;
            setColumns(data);
            // 🔥 Fetch comment counts only after tasks are set
            const allTasks = Object.values(data).flat();
            if (allTasks.length > 0) {
                fetchCommentCounts(allTasks);
            }
        } catch (error) {
            console.error("Error fetching tasks:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };



    // Fetch users from the API
    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetch-all-users`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            setUsers(response.data || []);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    // Fetch brands from the API
    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetchallbrands`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setBrands(response.data || []);
        } catch (error) {
            console.error("Error fetching brands:", error);
        }
    };
    useEffect(() => {
        fetchBrands();
        fetchTasks();
        fetchUsers();
    }, [accessToken, userId]);


    const fetchCommentCounts = async (tasks) => {
        try {
            const taskIds = tasks.map(task => task.task_id);

            if (taskIds.length === 0) return; // Avoid unnecessary API calls

            const response = await axios.get(`${config.apiBASEURL}/CommentRoutes/comment-count`, {
                params: { task_ids: taskIds },
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            setCommentCounts(response.data.counts || {}); // Use returned counts or fallback to empty object
        } catch (error) {
            console.error("Error fetching comment counts:", error);
        }
    };



    useEffect(() => {
        if (!accessToken) return;

        const fetchAndUpdateComments = () => {
            const updatedTasks = Object.values(columns).flat();
            if (updatedTasks.length > 0) {
                fetchCommentCounts(updatedTasks);
            }
        };

        fetchAndUpdateComments(); // Initial fetch

        const interval = setInterval(fetchAndUpdateComments, 3000); // Every 3s

        return () => clearInterval(interval);
    }, [accessToken, columns]); // Re-run when `columns` change



    // Filter brands for autocomplete
    const searchBrands = (event) => {
        const query = event.query.toLowerCase();
        setFilteredBrands(
            brands.filter((brand) =>
                brand.brand_name.toLowerCase().includes(query)
            )
        );
    };


    // Handle drag end
    const onDragEnd = async (result) => {
        const { source, destination, draggableId } = result;

        // If no destination or no change in position, return early
        if (!destination || (source.droppableId === destination.droppableId && source.index === destination.index)) {
            return;
        }

        const updatedColumns = { ...columns };
        const sourceColumn = [...updatedColumns[source.droppableId]];
        const destinationColumn = [...updatedColumns[destination.droppableId]];

        // Move the task within the columns
        const [movedTask] = sourceColumn.splice(source.index, 1);
        movedTask.status = destination.droppableId;
        destinationColumn.splice(destination.index, 0, movedTask);

        // Optimistically update UI
        updatedColumns[source.droppableId] = sourceColumn;
        updatedColumns[destination.droppableId] = destinationColumn;
        setColumns(updatedColumns);

        let updateSuccess = false;

        try {
            setIsLoading(true); // Set loading state
            const response = await axios.put(
                `${config.apiBASEURL}/projectRoutes/update-task-status`,
                {
                    user_id: userId,
                    task_id: draggableId,
                    new_column: destination.droppableId,
                    new_position: destination.index + 1,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                updateSuccess = true;

                // Call the API to add the task to the tasksheet
                await axios.post(
                    `${config.apiBASEURL}/tasksheetRoutes/update-tasksheet`,
                    {
                        task_id: draggableId,
                        status: destination.droppableId,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                // Fetch updated taskboard data

                fetchTasks();

            }
        } catch (error) {
            console.error("Error updating task position:", error);
            setVideocrossDialogVisible(true); // Show video dialog
            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide video dialog after 6 seconds
                fetchTasks();

            }, 2500);

        } finally {
            // Handle specific dialog logic in finally
            if (updateSuccess && destination.droppableId === 'InChanges') {
                const movedTaskDetails = { task_id: draggableId };
                setSelectedTask(movedTaskDetails);
                setDeadlineDialogVisible(true);
            }
        }
    };






    // Handle date range change
    const handleDateRangeChange = (start, end) => {
        setDateRange({
            startDate: moment(start),
            endDate: moment(end),
        });
    };

    const handleView = (taskId) => {
        setViewTaskId(taskId);
        setTaskDetailsVisible(true);
    };

    const closeTaskDetails = () => {
        setTaskDetailsVisible(false);
        setViewTaskId(null);
    };

    const handleNavigate = () => {
        navigate('/Graphe/dashboard/addtask');
    };

    const handleemployeeNavigate = () => {
        navigate('/Graphe/dashboard/Employee_add_task');
    };




    // Open the dialog and set the task ID
    const handleDuplicate = (taskId) => {
        setSelectedTaskId(taskId);
        setDialogVisible(true);
    };

    // Open the right sidebar
    const handleRightClick = (taskId) => {
        setSelectedTaskId(taskId); // Store the selected task ID
        setVisibleRight(true); // Open the sidebar
    };

    // Close the dialog
    const closeDialog = () => {
        setDialogVisible(false);
        setFormData({ startDate: null, endDate: null, userId: null });
    };

    // Handle form input changes
    const handleInputChange = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };


    const resetDialogState = () => {
        setSelectedTask(null);
        setNewDeadline(null);
        setDeadlineDialogVisible(false);
    };



    // Submit duplication
    const handleSubmit = async () => {
        try {
            const payload = {
                task_id: selectedTaskId,
                task_startdate: formData.startDate,
                task_deadline: formData.endDate,
                task_user_id: formData.userId,
            };

            const response = await axios.post(
                `${config.apiBASEURL}/projectRoutes/duplicate-task`,
                payload,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            if (response.status === 201 && response.data.message) {
                setSelectedTaskId(null); // Reset selected task ID
                closeDialog(); // Close the dialog   
                fetchTasks();

            } else {
                console.error("Failed to duplicate task:", response.data.error || response.data.message);

            }
        } catch (error) {
            console.error("Error duplicating task:", error.response?.data || error.message);

        }
    };


    const handleDeadlineUpdate = async () => {
        if (!selectedTask || !newDeadline) return;

        try {
            const response = await axios.put(
                `${config.apiBASEURL}/projectRoutes/update-task-deadline`,
                {
                    task_id: selectedTask.task_id,
                    new_deadline: newDeadline,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                fetchTasks(); // Refresh tasks to reflect changes
                setDeadlineDialogVisible(false);
                resetDialogState();
            } else {
                console.error("Failed to update deadline");
            }
        } catch (error) {
            console.error("Error updating deadline:", error);
        }
    };



    const handledelete = async (taskId) => {
        if (!taskId) return;
        setIsLoading(true);
        try {
            const response = await axios.delete(`${config.apiBASEURL}/projectRoutes/delete-task`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                data: {
                    user_id: userId,
                    task_id: taskId,
                },
            });

            if (response.status === 200) {
                await fetchTasks();
            }
        } catch (error) {
            const errMsg = error.response?.data?.error || 'Failed to delete the task.';
            // toast.error(errMsg);
        }
        setIsLoading(false);
    };





    const renderSkeletonLoader = () => {
        return Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="board-task skeleton-task">
                <Skeleton width="80%" height="1.5rem" className="mb-2" />
                <Skeleton width="60%" height="1rem" className="mb-2" />
                <Skeleton width="70%" height="1rem" className="mb-2" />
                <Skeleton width="90%" height="1rem" className="mb-2" />
                <Skeleton width="50%" height="1rem" />
            </div>
        ));
    };




    return (
        <Row className="body_content">
            <Row className="mx-0">
                <Col md={12} lg={12} className="mb-4 d-flex justify-content-between align-items-center">
                    <Breadcrumb>
                        <Breadcrumb.Item active>Taskboard</Breadcrumb.Item>
                    </Breadcrumb>
                    {allowedRoles.includes(role) && (
                        <Button
                            label="Add Task"
                            className="border-0 py-2"
                            icon="pi pi-plus"
                            severity="danger"
                            onClick={handleNavigate}
                        />
                    )}

                    {employeeallowedRoles.includes(role) && (
                        <Button
                            label="Add Task"
                            className="border-0 py-2"
                            icon="pi pi-plus"
                            severity="danger"
                            onClick={handleemployeeNavigate}
                        />
                    )}
                </Col>
                <Col md={12} lg={12} className="mb-4 d-flex flex-wrap justify-content-lg-end justify-content-start align-items-center">
                    {allowedRoles.includes(role) && (
                        <select
                            value={taskType}
                            onChange={(e) => setTaskType(e.target.value)}
                            className="form-select mx-1"
                            style={{ width: "150px" }}

                        >
                            <option value="">Select Department</option>
                            <option value="Graphe">Graphe</option>
                            <option value="Weddings">Weddings</option>
                            <option value="MoGraph">MoGraph</option>
                        </select>
                    )}
                    <Dropdown
                        value={includeCompleted}
                        options={completionOptions}
                        onChange={(e) => setIncludeCompleted(e.value)}
                        placeholder="Filter Completed Tasks"
                        style={{ width: "180px" }}
                    />
                    <AutoComplete
                        value={selectedBrand}
                        suggestions={filteredBrands}
                        completeMethod={searchBrands}
                        field="brand_name"
                        onChange={(e) => setSelectedBrand(e.value)}
                        placeholder="Select Brand"
                        className="mx-1"
                        style={{ width: "150px" }}
                    />


                    {allowedRoles.includes(role) && (
                        <AutoComplete
                            value={taskSearchUser}
                            suggestions={filteredUsers}
                            completeMethod={searchUsers}
                            field="first_name"
                            placeholder="Search User..."
                            onChange={(e) => setTaskSearchUser(e.value ?? "")} // Ensure it resets properly
                            itemTemplate={(item) => (
                                <span>{item.first_name} {item.last_name}</span>
                            )}
                            style={{ width: "150px" }}
                            className="mx-1"
                        />



                    )}

                    <select
                        id="dateFilterType"
                        value={dateFilterType}
                        onChange={(e) => setDateFilterType(e.target.value)}
                        className="form-select mx-1"
                        style={{ width: "120px" }}

                    >
                        <option value="startdate">Start Date</option>
                        <option value="deadline">Deadline</option>
                    </select>
                    <DateRangePicker
                        initialSettings={{
                            startDate: dateRange.startDate,
                            endDate: dateRange.endDate,
                            locale: { format: "DD/MM/YYYY" },
                            ranges: {
                                Today: [moment(), moment()],
                                Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                "This Month": [moment().startOf("month"), moment().endOf("month")],
                                "Last Month": [
                                    moment().subtract(1, "month").startOf("month"),
                                    moment().subtract(1, "month").endOf("month"),
                                ],
                            },
                        }}
                        onCallback={handleDateRangeChange}
                    >
                        <input
                            type="text"
                            className="form-control mx-1"
                            style={{ width: "180px" }}
                            placeholder="Select Date Range"
                        />
                    </DateRangePicker>
                    <Button
                        label="Apply"
                        className="border-0"
                        onClick={fetchTasks}
                        severity="secondary"
                    />







                </Col>

                <Col className="mb-4 bordmain">
                    <DragDropContext onDragEnd={onDragEnd}>
                        {Object.keys(columns).map((columnId) => (
                            <div key={columnId} className="subboard">
                                <div className="bordHeader">
                                    <h5 className="mb-0">{columnId}</h5>
                                </div>

                                <Droppable droppableId={columnId}>
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className="childboard scroll-card"
                                        >
                                            {isLoading
                                                ? renderSkeletonLoader() // Render skeletons while loading
                                                : columns[columnId].map((task, index) => (
                                                    <Draggable
                                                        key={task.task_id}
                                                        draggableId={task.task_id.toString()}
                                                        index={index}
                                                    >
                                                        {(provided) => (
                                                            <div
                                                                className={`board-task 
                                                    ${task.missed_deadline ? "task-red" : "task-green"} 
                                                    ${task.priority_flag === 'Priority' ? "example-1" : ""}`}
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    ...provided.draggableProps.style,
                                                                }}
                                                            >
                                                                <div>
                                                                    <p>
                                                                        <em>Brand :</em> <span>{task.brand_name}</span>
                                                                    </p>
                                                                    <p>
                                                                        <em>Project :</em> <span>{task.project_name}</span>
                                                                    </p>
                                                                    <p><em>Task : </em>{task.task_name}</p>
                                                                    <p>
                                                                        <em>Description: </em>
                                                                        <span>{task.task_description}</span>
                                                                    </p>
                                                                    <p>
                                                                        <em>End Date : </em>
                                                                        <span>
                                                                            {new Date(task.end_date).toLocaleDateString("en-GB")}
                                                                        </span>
                                                                    </p>
                                                                    <p>
                                                                        <em>Priority : </em>
                                                                        <Badge
                                                                            className={`badge ${task.priority === "High"
                                                                                ? "bg-danger" // Bootstrap class for red
                                                                                : task.priority === "Medium"
                                                                                    ? "bg-warning" // Bootstrap class for orange
                                                                                    : task.priority === "Low"
                                                                                        ? "bg-info" // Bootstrap class for green
                                                                                        : "bg-secondary" // Default Bootstrap gray
                                                                                }`}
                                                                        >
                                                                            {task.priority}
                                                                        </Badge>
                                                                    </p>
                                                                    <p className="d-flex w-100">
                                                                        <span className="d-flex align-items-center">
                                                                            <Avatar
                                                                                image={task.profile_image || noUserImg}
                                                                                shape="circle"
                                                                                className="mt-2 userName"
                                                                                data-pr-tooltip={`Assigned to : ${task.assignee_name}`}
                                                                                style={{ width: '26px', height: '26px' }}
                                                                            />
                                                                            <Tooltip target=".userName" mouseTrack mouseTrackLeft={10} />
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                                <hr className="mt-2" />
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                    }}
                                                                    className="taskBTN"
                                                                >
                                                                    <div style={{ display: "flex", gap: "10px" }}>
                                                                        {task.missed_deadline && (
                                                                            <div style={{ position: "relative" }}>
                                                                                <VscFlame
                                                                                    data-pr-tooltip="Deadline Missed"
                                                                                    data-pr-position="top"
                                                                                    className="missed-deadline-icon"
                                                                                    style={{
                                                                                        fontSize: "1.5rem",
                                                                                        color: "red",
                                                                                        marginRight: "auto",
                                                                                    }}
                                                                                />
                                                                                <Tooltip target=".missed-deadline-icon" />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div style={{ display: "flex" }}>
                                                                        <Button
                                                                            title="View"
                                                                            outlined
                                                                            severity="info"
                                                                            icon="pi pi-eye"
                                                                            className="border-0 p-0"
                                                                            onClick={() => handleView(task.task_id)} // Pass the task ID
                                                                        />
                                                                        <div className="position-relative">
                                                                            <Button
                                                                                title="Comments"
                                                                                outlined
                                                                                severity="help"
                                                                                icon="pi pi-comments"
                                                                                className="border-0 p-0"
                                                                                onClick={() => handleRightClick(task.task_id)} // Pass the task ID
                                                                            />
                                                                            <span className="comentCount">{commentCounts[task.task_id] || 0}</span>
                                                                        </div>

                                                                        {allowedRoles.includes(role) && (
                                                                            <CustomConfirmPopup
                                                                                message="Are you sure you want to duplicate this Task?"
                                                                                icon="pi pi-exclamation-triangle"
                                                                                defaultFocus="accept"
                                                                                acceptClassName="p-button-success"
                                                                                buttonLabel="Duplicate"
                                                                                title="Duplicate Task"
                                                                                buttonClass="p-button-secondary p-button-text"
                                                                                className="border-0 p-0"
                                                                                buttonIcon="pi pi-clone"
                                                                                onConfirm={() => handleDuplicate(task.task_id)}
                                                                                onReject={() => console.log('Duplicate action canceled')}
                                                                            />
                                                                        )}

                                                                        {allowedRoles.includes(role) && (
                                                                            <CustomConfirmPopup
                                                                                message="Are you sure you want to Delete this task?"
                                                                                icon="pi pi-exclamation-triangle"
                                                                                defaultFocus="accept"
                                                                                acceptClassName="p-button-danger"
                                                                                buttonLabel="Delete"
                                                                                title="Delete Task"
                                                                                buttonClass="p-button-danger p-button-text"
                                                                                className="border-0 p-0"
                                                                                buttonIcon="pi pi-trash"
                                                                                onConfirm={() => handledelete(task.task_id)}
                                                                                onReject={() => console.log('Delete action canceled')}
                                                                            />
                                                                        )}


                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </div>
                        ))}
                    </DragDropContext>
                </Col>


            </Row>
            <Dialog
                header="Duplicate Task"
                visible={isDialogVisible}
                style={{ width: "450px" }}
                onHide={closeDialog}
                footer={
                    <div>
                        <Button severity="danger" label="Cancel" icon="pi pi-times" onClick={closeDialog} className="p-button-text" />
                        <Button severity="success" className="p-button-text" label="Duplicate" icon="pi pi-check" onClick={handleSubmit} autoFocus />
                    </div>
                }
            >
                <div className="field">
                    <label htmlFor="startDate">Start Date</label>
                    <Calendar
                        id="startDate"
                        value={formData.startDate}
                        onChange={(e) => handleInputChange("startDate", e.value)}
                        showTime // Enables time selection
                        dateFormat="dd/mm/yy" // Formats the date
                        hourFormat="24" // Sets 24-hour format

                    />
                </div>
                <div className="field">
                    <label htmlFor="endDate">End Date</label>
                    <Calendar
                        id="endDate"
                        value={formData.endDate}
                        onChange={(e) => handleInputChange("endDate", e.value)}
                        showTime // Enables time selection
                        dateFormat="dd/mm/yy" // Formats the date
                        hourFormat="24" // Sets 24-hour format

                    />
                </div>

                <div className="field">
                    <label htmlFor="userId">Assign To</label>
                    <Dropdown
                        id="userId"
                        value={formData.userId}
                        options={users.map((user) => ({ label: user.first_name + " " + user.last_name, value: user.user_id }))}
                        onChange={(e) => handleInputChange("userId", e.value)}
                        placeholder="Select a User"
                    />
                </div>
            </Dialog>


            <Dialog

                visible={isDeadlineDialogVisible}
                style={{ width: '320px' }}
                onHide={() => setDeadlineDialogVisible(false)}
            >
                <div>
                    <label>Update Task Deadline</label>
                    <Calendar
                        value={newDeadline}
                        onChange={(e) => setNewDeadline(e.value)}
                        showTime
                        dateFormat="yy-mm-dd"
                    />
                    <div style={{ marginTop: '1em' }}>
                        <Button
                            outlined
                            icon="pi pi-check"
                            label="Update "
                            onClick={handleDeadlineUpdate}
                            className="py-2"
                            severity="info"
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

            <Dialog
                header="Task Details"
                visible={taskDetailsVisible}
                style={{ width: '900px', maxWidth: '95vw' }}
                onHide={closeTaskDetails}
                maximizable
                draggable={false}
            >
                {viewTaskId && (
                    <UnifiedTaskDetails taskId={viewTaskId} onClose={closeTaskDetails} />
                )}
            </Dialog>

            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '550px' }} dismissableMask={false} className='chatSidbar'
                content={({ closeIconRef, hide }) => (
                    <div className="d-flex flex-column justify-content-between h-100">
                        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                            <h6 className="mb-0 text-black"><i className="me-2"><TfiComments /></i><b>Comments</b></h6>
                            <span>
                                <Button type="button" ref={closeIconRef} onClick={(e) => hide(e)} severity="danger" text icon="pi pi-times" rounded outlined className="h-2rem w-2rem"></Button>
                            </span>
                        </div>
                        <Chat_page taskId={selectedTaskId} />
                    </div>
                )}
            ></Sidebar>

        </Row>

    );
};

export default Taskboard_admin;